import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    staticClass: "terminal-consulta"
  }, [_c('Keypress', {
    attrs: {
      "key-event": "keyup",
      "prevent-default": true,
      "key-code": _vm.teclasEnum.F2
    },
    on: {
      "success": _vm.buscarProduto
    }
  }), _c('header', {
    staticClass: "terminal-consulta__busca"
  }, [_c('CardBuscaTerminal', {
    scopedSlots: _vm._u([{
      key: "formulario",
      fn: function fn() {
        return [_c('Select', {
          ref: "buscarProduto",
          attrs: {
            "input-class": "terminal-search",
            "placeholder": "Informe o código, descrição, código de barras ou referência do produto",
            "label-busca": "descricao",
            "options": _vm.produtos,
            "change": _vm.setProduto,
            "search": _vm.onSearch,
            "focus": ""
          },
          scopedSlots: _vm._u([{
            key: "options",
            fn: function fn(props) {
              return [!props.data.isKit ? _c('div', {
                staticClass: "resultado-busca"
              }, [_c('div', {
                staticClass: "resultado-busca__titulo"
              }, [_c('span', [_vm._v(_vm._s(props.data.codigo) + " - " + _vm._s(props.data.descricao))]), _c('span', {
                staticClass: "resultado-busca__marcadores"
              }, [_vm.possuiVariacao(props.data) ? _c('small', [_vm._v("Variações")]) : _vm._e(), _vm.possuiLote(props.data) ? _c('small', [_vm._v("Lotes")]) : _vm._e()])]), _c('div', {
                staticClass: "resultado-busca__resumo"
              }, [_c('span', [_vm._v(" R$ " + _vm._s(_vm.numberToReal(parseFloat(props.data.preco), "preco")) + _vm._s(_vm.getPrecoAtacadoInfo(props.data)) + " ")]), _c('span', [_vm._v(" Qtd.: " + _vm._s(_vm.numberToReal(parseFloat(props.data.quantidade), "quantidade")) + " ")])])]) : _c('div', {
                staticClass: "resultado-busca resultado-busca--kit"
              }, [_c('span', [_vm._v(" " + _vm._s(props.data.codigo) + " - " + _vm._s(props.data.descricao) + " "), _c('span', {
                directives: [{
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.html.right",
                  modifiers: {
                    "hover": true,
                    "html": true,
                    "right": true
                  }
                }],
                attrs: {
                  "id": "kitInfo",
                  "title": _vm.getKitInfo(props.data)
                }
              }, [_c('InformationOutline', {
                attrs: {
                  "size": 14
                }
              })], 1)]), _c('span', {
                staticClass: "text-muted"
              }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.data.totalPrice, "preco")) + " ")])])];
            }
          }]),
          model: {
            value: _vm.produto,
            callback: function callback($$v) {
              _vm.produto = $$v;
            },
            expression: "produto"
          }
        })];
      },
      proxy: true
    }])
  })], 1), !_vm.produto ? _c('section', {
    staticClass: "terminal-consulta__vazio"
  }, [_c('div', {
    staticClass: "terminal-consulta__icone"
  }, [_c('BarcodeScan', {
    attrs: {
      "size": 96
    }
  })], 1), _c('h1', [_vm._v("Consulte um produto")]), _c('p', [_vm._v("Use a busca acima ou pressione F2 para começar.")])]) : _c('section', {
    staticClass: "produto-consultado",
    attrs: {
      "aria-live": "polite"
    }
  }, [_c('article', {
    staticClass: "produto-resumo"
  }, [_vm.urlProdutoImage ? _c('div', {
    staticClass: "produto-resumo__imagem"
  }, [_c('img', {
    attrs: {
      "src": _vm.urlProdutoImage,
      "alt": "Imagem de ".concat(_vm.produto.descricao)
    }
  })]) : _c('div', {
    staticClass: "produto-resumo__imagem produto-resumo__imagem--vazia"
  }, [_c('BarcodeScan', {
    attrs: {
      "size": 44
    }
  })], 1), _c('div', {
    staticClass: "produto-resumo__conteudo"
  }, [_c('div', {
    staticClass: "produto-resumo__codigo"
  }, [_vm._v("Código " + _vm._s(_vm.produto.codigo))]), _c('h1', [_vm._v(_vm._s(_vm.produto.descricao))]), _c('div', {
    staticClass: "produto-resumo__marcadores"
  }, [_vm.temVariacoes ? _c('span', {
    staticClass: "marcador marcador--variacao"
  }, [_vm._v(" Produto com variações ")]) : _vm._e(), _vm.temLotes ? _c('span', {
    staticClass: "marcador marcador--lote"
  }, [_vm._v(" Produto com lotes ")]) : _vm._e()])]), _c('button', {
    staticClass: "nova-consulta",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.buscarProduto
    }
  }, [_vm._v(" Nova consulta "), _c('span', {
    staticClass: "nova-consulta__atalho"
  }, [_vm._v("F2")])])]), _c('div', {
    staticClass: "produto-indicadores"
  }, [_c('article', {
    staticClass: "indicador indicador--preco"
  }, [_c('span', [_vm._v("Preço")]), _c('strong', [_vm._v("R$ " + _vm._s(_vm.numberToReal(_vm.produto.preco, "preco")))])]), _vm.getPrecoAtacado(_vm.produto) > 0 ? _c('article', {
    staticClass: "indicador indicador--atacado"
  }, [_c('span', [_vm._v("Preço no atacado")]), _c('strong', [_vm._v(" R$ " + _vm._s(_vm.numberToReal(_vm.getPrecoAtacado(_vm.produto), "preco")) + " ")])]) : _vm._e(), _c('article', {
    staticClass: "indicador indicador--estoque"
  }, [_c('span', [_vm._v("Estoque total disponível")]), _c('strong', [_vm._v(_vm._s(_vm.numberToReal(_vm.produto.quantidade, "quantidade")))]), _c('small', [_vm._v(_vm._s(_vm.formatarUnidadeMedida(_vm.produto.unidade_medida)))])])]), _vm.carregandoDetalhes ? _c('div', {
    staticClass: "detalhes-carregando"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Carregando detalhes"
    }
  }), _c('span', [_vm._v("Carregando variações e lotes...")])], 1) : _vm._e(), _vm.erroDetalhes ? _c('b-alert', {
    staticClass: "mb-4",
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.erroDetalhes) + " ")]) : _vm._e(), _vm.temVariacoes ? _c('section', {
    staticClass: "estoque-detalhe"
  }, [_c('div', {
    staticClass: "estoque-detalhe__cabecalho"
  }, [_vm._m(0), _vm.variacoes.length > 6 ? _c('label', {
    staticClass: "filtro-detalhes"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Filtrar variações")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.filtroVariacao,
      expression: "filtroVariacao",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "Filtrar por cor, tamanho..."
    },
    domProps: {
      "value": _vm.filtroVariacao
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.filtroVariacao = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e()]), _vm.variacoesFiltradas.length ? _c('div', {
    staticClass: "variacoes-grid"
  }, _vm._l(_vm.variacoesFiltradas, function (variacao) {
    return _c('article', {
      key: "variacao-".concat(variacao.id),
      staticClass: "variacao-card"
    }, [_c('div', {
      staticClass: "variacao-card__atributos"
    }, _vm._l(variacao.atributos, function (atributo) {
      return _c('div', {
        key: "".concat(variacao.id, "-").concat(atributo.nome),
        staticClass: "atributo"
      }, [_c('span', [_vm._v(_vm._s(atributo.nome))]), _c('strong', [_vm._v(_vm._s(atributo.valor))])]);
    }), 0), _c('div', {
      staticClass: "saldo",
      class: _vm.classeSaldo(variacao.quantidade),
      attrs: {
        "aria-label": "".concat(variacao.quantidade, " unidades dispon\xEDveis")
      }
    }, [_c('strong', [_vm._v(" " + _vm._s(_vm.numberToReal(variacao.quantidade, "quantidade")) + " ")]), _c('span', [_vm._v("disponível")])])]);
  }), 0) : _c('div', {
    staticClass: "estoque-detalhe__vazio"
  }, [_vm._v(" " + _vm._s(_vm.filtroVariacao ? "Nenhuma variação corresponde ao filtro." : "Nenhuma variação cadastrada para exibir.") + " ")])]) : _vm._e(), _vm.temLotes ? _c('section', {
    staticClass: "estoque-detalhe"
  }, [_c('div', {
    staticClass: "estoque-detalhe__cabecalho"
  }, [_vm._m(1), _vm.lotes.length > 6 ? _c('label', {
    staticClass: "filtro-detalhes"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Filtrar lotes")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.filtroLote,
      expression: "filtroLote",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "search",
      "placeholder": "Filtrar pelo número do lote"
    },
    domProps: {
      "value": _vm.filtroLote
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.filtroLote = $event.target.value.trim();
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e()]), _vm.lotesFiltrados.length ? _c('div', {
    staticClass: "lotes-grid"
  }, _vm._l(_vm.lotesFiltrados, function (lote) {
    return _c('article', {
      key: "lote-".concat(lote.id),
      staticClass: "lote-card"
    }, [_c('div', {
      staticClass: "lote-card__topo"
    }, [_c('div', [_c('span', [_vm._v("Número do lote")]), _c('strong', [_vm._v(_vm._s(lote.numero))])]), _vm.loteVencido(lote) ? _c('span', {
      staticClass: "lote-vencido"
    }, [_vm._v("Vencido")]) : _vm._e()]), _c('dl', {
      staticClass: "lote-card__datas"
    }, [_c('div', [_c('dt', [_vm._v("Fabricação")]), _c('dd', [_vm._v(_vm._s(_vm.formatarDataLote(lote.dataFabricacao)))])]), _c('div', [_c('dt', [_vm._v("Validade")]), _c('dd', [_vm._v(_vm._s(_vm.formatarDataLote(lote.dataValidade)))])])]), _c('div', {
      staticClass: "saldo saldo--lote",
      class: _vm.classeSaldo(lote.quantidade)
    }, [_c('strong', [_vm._v(_vm._s(_vm.numberToReal(lote.quantidade, "quantidade")))]), _c('span', [_vm._v("disponível")])])]);
  }), 0) : _c('div', {
    staticClass: "estoque-detalhe__vazio"
  }, [_vm._v(" " + _vm._s(_vm.filtroLote ? "Nenhum lote corresponde ao filtro." : "Nenhum lote cadastrado para exibir.") + " ")])]) : _vm._e(), _c('footer', {
    staticClass: "produto-consultado__rodape"
  }, [_c('button', {
    staticClass: "nova-consulta nova-consulta--rodape",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.buscarProduto
    }
  }, [_vm._v(" Consultar outro produto ")])])], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "estoque-detalhe__rotulo"
  }, [_vm._v("Estoque detalhado")]), _c('h2', [_vm._v("Variações")]), _c('p', [_vm._v("Saldo disponível em cada combinação do produto.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "estoque-detalhe__rotulo"
  }, [_vm._v("Rastreabilidade")]), _c('h2', [_vm._v("Lotes")]), _c('p', [_vm._v("Validade e saldo disponível por lote.")])]);
}];
export { render, staticRenderFns };